// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DbcYB","colBig":"styles_colBig__sEjti","colSmall":"styles_colSmall__347Wn"};